import classNames from '@ui-components-3/ui/lib/utils/classNames'
import { ReactNode } from 'react'

export type BadgeVariant =
  | 'success'
  | 'error'
  | 'error-solid'
  | 'warning'
  | 'warning-solid'
  | 'warning-strong-solid'
  | 'neutral'
  | 'neutral-solid'
  | 'primary-solid'

const variantClassNames: Record<BadgeVariant, string> = {
  success: 'border-unnamed-1 bg-[#F1FFFB] text-unnamed-4',
  error: 'border-fuchsia-400 bg-fuchsia-100 text-fuchsia-700',
  'error-solid': 'bg-fuchsia-700 border-fuchsia-700 text-white',
  warning: 'border-pantone-500 bg-pantone-300 text-pantone-800',
  'warning-solid': 'bg-pantone-600 border-pantone-600 text-neutral-800',
  'warning-strong-solid': 'bg-[#C55011] border-[#C55011] text-white',
  neutral: 'border-neutral-400 bg-neutral-300 text-neutral-800',
  'neutral-solid': 'bg-neutral-800 border-neutral-800 text-white',
  'primary-solid': 'bg-primary-600 border-primary-600 text-white',
}

type BadgeProps = {
  children: ReactNode
  variant: BadgeVariant
  className?: string
}

// TODO - move this component to ui-components-3 library
const Badge = ({ children, variant, className }: BadgeProps) => {
  const variantClassName = variantClassNames[variant] || variantClassNames.neutral

  return (
    <span
      className={classNames(
        'typography-small inline-flex items-center justify-center gap-1 rounded-full border px-3 py-1 text-center font-semibold leading-4',
        variantClassName,
        className,
      )}
    >
      {children}
    </span>
  )
}

export default Badge
